import React from 'react';

export const Services = (props) => {
  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2
            style={{
              fontSize: '2.5rem',
              fontWeight: 'bold',
              color: 'white',
              marginBottom: 12,
            }}
          >
            Our Services
          </h2>
          <p>
            Discover our full spectrum of digital, analytics, cloud, and AI
            services designed to accelerate your business transformation.
          </p>
        </div>
        <div
          className="row"
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
          }}
        >
          {props.data
            ? props.data.map((d, i) => (
                <div
                  key={`${d.name}-${i}`}
                  className="col-md-4"
                  style={{
                    flex: '1 1 22%', // About 4 per row on large screens
                    minWidth: 260,
                    maxWidth: 340,
                    boxSizing: 'border-box',
                    marginBottom: 32,
                  }}
                >
                  <i className={d.icon}></i>
                  <div className="service-desc">
                    <h3>{d.name}</h3>
                    <p>{d.text}</p>
                  </div>
                </div>
              ))
            : 'loading'}
        </div>
      </div>
    </div>
  );
};
